var map = {
	"./category/_id.vue": [
		"c026",
		"chunk-48a6584c",
		"chunk-3706efc7"
	],
	"./game/_id.vue": [
		"b02a",
		"chunk-48a6584c",
		"chunk-671b64e3"
	],
	"./index/index.vue": [
		"37f9",
		"chunk-48a6584c",
		"chunk-38d88ea3"
	],
	"./layouts/main.vue": [
		"5658",
		"chunk-6cb0cc08"
	],
	"./pages/about.vue": [
		"ff3c",
		"chunk-cd1ede94"
	],
	"./pages/contact.vue": [
		"c444",
		"chunk-59fa5782"
	],
	"./pages/privacy.vue": [
		"6b32",
		"chunk-0e05c7f3"
	],
	"./pages/terms.vue": [
		"689d",
		"chunk-20e86390"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;